import api from "@/services/api";
import type {
  PrepareForPanelListFilterKeywords,
  PrepareForPanelListRequest,
  PrepareForPanelListResponse,
  PrepareForPanelListSortOrder,
} from "@/components/PrepareForPanelList/types/prepareForPanelListApi.types";
import { EMPTY_PREPARE_FOR_PANEL_LIST_FILTER_KEYWORDS } from "@/components/PrepareForPanelList/types/prepareForPanelListApi.types";
import { normalizePrepareForPanelListResponse } from "@/components/PrepareForPanelList/utils/prepareForPanelListApiTransform";

const { productServiceAPI } = api;

const PREPARE_FOR_PANEL_LIST_PATH = "/idea/prePanelList";

function normalizeStringArray(v: unknown): string[] {
  if (!Array.isArray(v)) return [];
  return v.map((x) => String(x).trim()).filter(Boolean);
}

function normalizeVendorArray(v: unknown): string[] {
  if (!Array.isArray(v)) return [];
  return v.map((x) => String(x).trim()).filter(Boolean);
}

function normalizeFilterKeywordsForPost(
  fk: PrepareForPanelListFilterKeywords | undefined
): PrepareForPanelListFilterKeywords {
  const o = fk ?? EMPTY_PREPARE_FOR_PANEL_LIST_FILTER_KEYWORDS;
  return {
    productType: normalizeStringArray(o.productType),
    businessStatus: normalizeStringArray(o.businessStatus),
    businessCategoryName: normalizeStringArray(o.businessCategoryName),
    categoryManager: normalizeStringArray(o.categoryManager),
    developer: normalizeStringArray(o.developer),
    vendor: normalizeVendorArray(o.vendor),
  };
}

export function buildPrepareForPanelListPostBody(
  payload: PrepareForPanelListRequest
): PrepareForPanelListRequest {
  const sortOrder: PrepareForPanelListSortOrder = payload.sortOrder === "ASC" ? "ASC" : "DESC";

  return {
    pageNo: Math.max(0, Math.floor(Number(payload.pageNo) || 0)),
    pageSize: Math.max(1, Math.floor(Number(payload.pageSize) || 10)),
    search: typeof payload.search === "string" ? payload.search : "",
    sortBy: typeof payload.sortBy === "string" && payload.sortBy.trim() ? payload.sortBy.trim() : "id",
    sortOrder,
    filterKeywords: normalizeFilterKeywordsForPost(payload.filterKeywords),
  };
}

async function postPrepareForPanelList(
  payload: PrepareForPanelListRequest
): Promise<PrepareForPanelListResponse> {
  const body = buildPrepareForPanelListPostBody(payload);
  const resp = await productServiceAPI.post<unknown>(PREPARE_FOR_PANEL_LIST_PATH, body);

  const totalHeader =
    (resp as { headers?: Record<string, string> })?.headers?.["x-total-count"] ??
    (resp as { headers?: Record<string, string> })?.headers?.["X-Total-Count"];

  return normalizePrepareForPanelListResponse(resp.data, body, totalHeader);
}

export { normalizePrepareForPanelListResponse } from "@/components/PrepareForPanelList/utils/prepareForPanelListApiTransform";

export async function postPrepareForPanelActiveList(
  payload: PrepareForPanelListRequest
): Promise<PrepareForPanelListResponse> {
  return postPrepareForPanelList(payload);
}

const PrepareForPanelListService = {
  postActiveList: postPrepareForPanelActiveList,
};

export default PrepareForPanelListService;
